import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import loadConfig from "../../Services/apiService";
import MyRequestsPage from "../../PagesManager/MyRequestsPage";

const MyRequestsContainer = () => {
  return (
    <>
      <SharedDiv
        showTitle={true}
        titleName="طلباتي"
        child={[<MyRequestsPage />]}
      />
    </>
  );
};
export default MyRequestsContainer;
